import React from 'react';
import APIKeysContent from '../components/APIKeysContent';

const APIKeysPage: React.FC = () => {
  return (
    <div className="mx-auto px-4 sm:px-6 lg:px-8 py-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white transition-colors">
          API Keys
        </h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400 transition-colors">
          Create and manage API keys for authenticating your agents with the Aivilo SDK
        </p>
      </div>

      {/* Content */}
      <APIKeysContent />
    </div>
  );
};

export default APIKeysPage;
